import { IS_BILLING, IS_DEV } from "@/constants";
import PublicLayout from "@/layouts/PublicLayout";
import CompleteProfile from "@/modules/CompleteProfile";
import ForgetPassword from "@/modules/ForgetPassword";
import Login from "@/modules/Login";
import UpdatePassword from "@/modules/UpdatePassword";
import routes from "@/routes";
import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const Register = lazy(() => import("@/modules/Register"));

const TableLab = lazy(() => import("@/modules/TableLab"));

export const PublicRoutes: RouteObject[] = [
  // Design harness for table layout. Outside PublicLayout so it renders without
  // the login chrome, and dropped from the bundle entirely outside development —
  // it is a working surface, not a feature. It needs no user: UserProvider wraps
  // both route trees and `usePermission` tolerates a null user, so the fixture
  // tables render with nobody logged in.
  ...(IS_DEV ? [{ element: <TableLab />, path: "/table-lab" }] : []),
  {
    element: <PublicLayout />,
    path: "/",
    children: [
      {
        element: <Login />,
        path: "/",
      },
      {
        element: <Login isAdmin />,
        path: "/admin",
      },
      ...(IS_BILLING
        ? [
            {
              element: <Register />,
              path: routes.REGISTER,
            },
          ]
        : []),
      {
        element: <ForgetPassword />,
        path: routes.FORGET_PASSWORD,
      },
      {
        element: <UpdatePassword />,
        path: routes.UPDATE_PASSWORD,
      },
      {
        element: <CompleteProfile />,
        path: "/complete-profile",
      },
    ],
  },
];
